import type { InvoiceDetailDto } from "@hisense/shared";
import { documentTotals } from "./documentTotals";

/**
 * Các con số của MỘT hoá đơn — một nguồn duy nhất cho bản in, CSV và Excel.
 *
 * Trước 15/09/2026 ba nơi tự tính lấy, và hai trong ba làm tròn khác nhau:
 * bản in lấy `totalMinor(dòng + phụ phí)`, còn CSV lấy
 * `totalMinor(totalMinor(dòng) + phụ phí)` — làm tròn hai lần. Hai công thức
 * chênh nhau một xu ở đúng những số nằm giữa, nên cùng một hoá đơn xuất ra
 * hai tệp có thể ghi hai con số "gốc sau làm tròn" khác nhau. Tệ hơn: tổng
 * cuối thì cả hai đều lấy `piTotalMinor`, nên bản CSV tự mâu thuẫn với chính
 * nó — cộng cột không ra dòng tổng cuối của chính nó.
 *
 * `piTotalMinor` là trọng tài: nó là hàm đã tính ra con số lưu trong CSDL.
 * Mọi thứ ở đây bám theo nó, không phải ngược lại.
 */
export function invoiceDocumentFacts(inv: InvoiceDetailDto) {
  const { lineSubtotal, base, discountPct, less, grand: recomputed } = documentTotals(inv);
  /**
   * Tổng cuối lấy con số ĐÃ LƯU, không tính lại.
   *
   * `inv.totalAmount` là thứ khách đã nhận và kế toán đã ghi sổ. Nếu nó lệch
   * với phép tính thì đó là tin phải NÓI RA (xem `recomputed`), không phải thứ
   * để bản in lặng lẽ đè lên bằng một con số đẹp hơn.
   */
  const grand = inv.totalAmount;
  return { lineSubtotal, base, discountPct, less, grand, recomputed, drifted: grand !== recomputed };
}

/**
 * Tên tệp an toàn cho mọi hệ điều hành.
 *
 * Số hoá đơn do người dùng nhập nên có thể chứa `/` — trên máy Mac và Linux đó
 * là dấu phân cấp thư mục, và tệp tải về sẽ rơi vào chỗ không ai tìm ra.
 */
// eslint-disable-next-line no-control-regex -- CỐ Ý: lọc ký tự điều khiển ra khỏi tên tệp.
export const invoiceFileName = (invNo: string) => `invoice-${invNo.replace(/[\\/:*?"<>|\u0000-\u001f]/g, "_")}`;
